import { createSlice } from "@reduxjs/toolkit";

//Vigencia del filtro inducido (navFilter). Vive lo justo para sobrevivir a
//los remontajes de la pantalla destino —replay de StrictMode, montaje de la
//pestaña en Mi Puesto—, que ocurren en el mismo instante de la navegacion.
//Pasada la ventana deja de aplicar: volver al tracking mas tarde lo abre
//completo y no pegado al registro de la navegacion anterior (hallazgo de
//Diego 2026-08-13).
export const VIGENCIA_NAVFILTER = 30000;

const customFilters = {
  page: 1,
  perPage: process.env.REACT_APP_ROWS_PER_PAGE_TRACKING,
  sorts: "-REGFECXX,-REGHORXX",
};

const trackingSlice = createSlice({
  name: "tracking",
  initialState: {
    contexto: "",
    data: {},
    columns: [],
    colsTracking: [],
    customFilters: customFilters,
    totalData: 0,
    filters: [],
    showModalConsult: false,
    extraFilters: [],
    hideColumn: {},
    modalShow: "",
    restoreFilts: false,
    external: false,
    functionToExecute: { execute: false, functionName: null, ciacidxx: null },
    // Filtro de navegacion pendiente: { target: "MODURLXX.PRODURLX", filters: [...] }.
    // Trackhea lo RE-APLICA en su limpieza de montaje en vez de borrarlo
    // (la limpieza corre en momentos arbitrarios: montajes, replays de
    // StrictMode, refresh) y lo descarta al cambiar de pantalla o cuando
    // el usuario busca/limpia manualmente.
    navFilter: null,
    // Contexto embebido (Mi Puesto): cuando una pantalla de proceso vive
    // dentro del workspace, el tracking y las opciones de menu resuelven
    // contra su proceso REAL, no contra el proceso anfitrion.
    // { MODIDXXX, PROIDXXX, MODURLXX, PRODURLX } | null
    contextOverride: null,
    checkedRows: [],
    ischeckedAll: false,
  },
  reducers: {
    setData: (state, action) => {
      state.data = action.payload;
    },
    setColumns: (state, action) => {
      state.columns = action.payload;
    },
    setColsTracking: (state, action) => {
      state.colsTracking = action.payload;
    },
    setCustomFilters: (state, action) => {
      state.customFilters = action.payload;
    },
    //El tracking es un estado COMPARTIDO por todas las pantallas: al cambiar
    //de proceso, el sort/pagina de la pantalla anterior no puede filtrarse a
    //la nueva (un -ESTGEPES de Mis Tareas reventaba Planeacion Importaciones
    //con "Unknown column" — #381). Cada pantalla registra su contexto y, si
    //cambio, el estado vuelve a los valores por defecto.
    setContextoTracking: (state, action) => {
      if (state.contexto !== action.payload) {
        state.contexto = action.payload;
        state.customFilters = { page: 1, perPage: state.customFilters?.perPage ?? 15, sorts: "-REGFECXX,-REGHORXX" };
        state.filters = [];
      }
    },
    setSortTracking: (state, action) => {
      state.customFilters = { ...state.customFilters, sorts: action.payload };
    },
    setTotalData: (state, action) => {
      state.totalData = action.payload;
    },
    cleanDataTracking: (state) => {
      state.dataTracking = {};
    },
    setFiltersTracking: (state, action) => {
      state.filters = action.payload;
    },
    resetFilters: (state) => {
      state.filters = {};
    },
    setExtraFilters: (state, action) => {
      state.extraFilters = action.payload;
    },
    setHideColumn: (state, action) => {
      state.hideColumn = action.payload;
    },
    setModalShow: (state, action) => {
      state.modalShow = action.payload;
    },
    resetCustomFilters: (state) => {
      state.customFilters = customFilters;
    },
    setRestoreFilts: (state, action) => {
      state.restoreFilts = action.payload;
    },
    setExternal: (state, action) => {
      state.external = action.payload;
    },
    setContextOverride: (state, action) => {
      state.contextOverride = action.payload;
    },
    setFunctionToExecute: (state, action) => {
      state.functionToExecute = action.payload;
    },
    setNavFilter: (state, action) => {
      state.navFilter = action.payload;
    },
    resetFunctionToExecute: (state) => {
      console.log("estoy eliminando LOS DATOS DE LA FUNCION");
      state.functionToExecute = { execute: false, functionName: null, ciacidxx: null };
      console.log(state);
    },
    setCheckedRows: (state, action) => {
      state.checkedRows = action.payload;
    },
    setIscheckedAll: (state, action) => {
      state.ischeckedAll = action.payload;
    },
    resetCheckedRows: (state) => {
      state.checkedRows = [];
      state.ischeckedAll = false;
    },
  },
});
export const {
  setData,
  setColumns,
  setColsTracking,
  setCustomFilters,
  setTotalData,
  cleanDataTracking,
  setFiltersTracking,
  resetFilters,
  setExtraFilters,
  setHideColumn,
  setFunctionConsult,
  setModalShow,
  resetCustomFilters,
  setSortTracking,
  setRestoreFilts,
  setExternal,
  setContextOverride,
  setFunctionToExecute,
  resetFunctionToExecute,
  setNavFilter,
  setCheckedRows,
  setIscheckedAll,
  resetCheckedRows, setContextoTracking, } = trackingSlice.actions;
export default trackingSlice.reducer;

//Export Data
export const getData = (state) => {
  return state.tracking.data;
};
//Export Columns
export const getColumns = (state) => {
  return state.tracking.columns;
};
//Columnas del tracking
export const getColsTracking = (state) => {
  return state.tracking.colsTracking;
};
//Filtros personalizados
export const getCustomFilters = (state) => {
  return state.tracking.customFilters;
};
//Total Data
export const getTotalData = (state) => {
  return state.tracking.totalData;
};
//Filtros del tracking
export const getFiltersTracking = (state) => {
  return state.tracking.filters;
};
export const getExtraFilters = (state) => {
  return state.tracking.extraFilters;
};
export const getHideColumn = (state) => {
  return state.tracking.hideColumn;
};
export const getModalShow = (state) => {
  return state.tracking.modalShow;
};
export const getRestoreFilts = (state) => {
  return state.tracking.restoreFilts;
};
export const getContextOverride = (state) => state.tracking.contextOverride;
export const getExternal = (state) => {
  return state.tracking.external;
};
export const getFunctionToExecute = (state) => state.tracking.functionToExecute;
export const getNavFilter = (state) => state.tracking.navFilter;

export const getCheckedRows = (state) => {
  return state.tracking.checkedRows;
};

export const getIsChekedAll = (state) => {
  return state.tracking.ischeckedAll;
};
